<template>
  <div class="page" v-loading="loading">
    <el-tabs v-model="form.resellerId" @tab-click="handleReseller">
      <el-tab-pane :label="item.name" :name="item.id" v-for="(item, index) in reseller" :key="index"></el-tab-pane>
    </el-tabs>
    <el-form :model="form" label-width="90px" ref="form">
      <div class="flex-wrap">
        <el-form-item inline label="钱包余额：" class="mgr30">
          <h2>¥{{ detail.balance }}</h2>
        </el-form-item>
        <el-form-item inline label="提现待审核:" class="mgr30">
          <span>¥{{ detail.withdrawing }}</span>
        </el-form-item>
        <el-form-item inline label="服务保证金:" class="mgr30">
          <span>¥{{ detail.earnest }}</span>
          <span class="earnestRule" @click="earnestRuleVisible = true">规则</span>
          <span class="pzRule" @click="checkCertificate">凭证</span>
        </el-form-item>
      </div>
      <el-form-item label-width="0">
        <el-button class="mgl10" type="primary"
          @click="$router.push(`/Financial/WalletAccount/WithdrawDeposit?id=${form.resellerId}`)">提现</el-button>

        <el-button type="primary" @click="loanReturnVisible = true">货款返还</el-button>
        <el-button type="primary"
          @click="$router.push(`/Financial/WalletAccount/Password?id=${detail.id}`)">提现密码设置</el-button>
      </el-form-item>
      <el-form-item label-width="0">
        <div style="font-size: 13px;">（每日可提现1次）</div>
      </el-form-item>
      <el-form-item label-width="0">
        <h2>收支明细</h2>
      </el-form-item>
      <el-row>
        <el-col :span="8">
          <el-form-item label="类型" prop="RecordType">
            <el-select v-model="form.RecordType" class="w100">
              <el-option :value="null" label="全部"></el-option>
              <el-option :value="1" label="系统充值"></el-option>
              <el-option :value="2" label="系统扣款"></el-option>
              <el-option :value="4" label="货款返还"></el-option>
              <el-option :value="5" label="订单结算"></el-option>
              <el-option :value="6" label="订单结算退款"></el-option>
              <el-option :value="7" label="提现"></el-option>
              <el-option :value="8" label="提现驳回"></el-option>
              <el-option :value="9" label="退款运费"></el-option>
              <el-option :value="10" label="订单补偿扣款"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="时间">
            <el-date-picker class="w100" v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="备注" prop="Note">
            <el-input v-model="form.Note" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item>
            <div class="flex">
              <el-button type="primary" @click="getData">查询</el-button>
              <el-button @click="resetForm">重置</el-button>
              <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="tableData" border style="width: 100%;" :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }">
      <el-table-column label="金额">
        <template slot-scope="scope">¥{{ scope.row.amount }}</template>
      </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">{{ scope.row.typeDesc }}</template>
      </el-table-column>
      <el-table-column label="时间" prop="createTime"></el-table-column>
      <el-table-column label="备注" prop="note">
        <template slot-scope="scope">
          <p>{{ scope.row.note }}</p>
          <div v-if="scope.row.type === 5 || scope.row.type === 6 || scope.row.type === 9">
            <p>外部子订单号：{{ scope.row.orderNo }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="当时余额">
        <template slot-scope="scope">¥{{ scope.row.currentBalance }}</template>
      </el-table-column>
      <el-table-column label="回单地址" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="lookReceiptUrl(scope.row.receiptUrl)">{{ scope.row.receiptUrl }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="form.PageIndex" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="form.PageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
    <!-- 货款返还 -->
    <el-dialog title="货款返还" :visible.sync="loanReturnVisible" width="40%" :before-close="loanReturnClose"
      v-loading="loading">
      <p>请使用提现的银行账号将款项打至我行账户，打款成功后，上传凭证提交申请，凭证有误或金额有误等问题将无法通过，请谨慎操作！</p>
      <el-form :model="loanReturn" :rules="loanReturnRule" ref="loanReturnForm" label-width="100px" class="mgt20">
        <el-form-item label-width="0">
          <el-card shadow="never" class="card">
            <el-form-item label="银行账号：">121916004410703</el-form-item>
            <el-form-item label="账户名称：">上海赢可通信息科技有限公司</el-form-item>
            <el-form-item label="银行名称：">招商银行</el-form-item>
            <el-form-item label="所属支行：">招商银行上海分行金桥支行</el-form-item>
          </el-card>
        </el-form-item>
        <el-form-item label="充值金额" prop="amount">
          <el-input v-model="loanReturn.amount"></el-input>
        </el-form-item>
        <el-form-item label="打款凭证" prop="certificate">
          <div class="img-box">
            <el-upload class="el_upload" action="#" :auto-upload="false" :show-file-list="false"
              :on-change="handleChange">
              <img v-if="loanReturn.certificate" :src="loanReturn.certificate" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <span class="mask" v-if="loanReturn.certificate">
                <span @click.stop="delPic()">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input type="textarea" v-model="loanReturn.note"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="loanReturnClose">取 消</el-button>
        <el-button type="primary" @click="loanReturnSure">提交申请</el-button>
      </span>
    </el-dialog>

    <el-dialog title="服务保证金规则" :visible.sync="earnestRuleVisible" width="50%">
      <div>
        <b>缴纳标准：</b>
        累计销售（供货）额达20万，或入驻超3个月，需缴纳2000元服务保证金。
      </div>
      <div style="margin-top:10px">
        <b>退还标准：</b>
        闭店申请提交后，满6个月，且无未完结的售后等，可申请退还/提现。
      </div>
      <span slot="footer">
        <el-button type="primary" @click="earnestRuleVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 营客通服务保证金凭证 -->
    <el-dialog title="营客通服务保证金凭证" :visible.sync="certificateVisible" width="50%">
      <div class="certificateContent" v-loading="certificateLoading">
        <div class="innerContent" v-if="certificateData">
          <div class="title">营客通服务保证金凭证</div>
          <div class="base-info">
            凭证编号: {{ certificateData.certificateNo }}<br>
            凭证类型: 服务保证金<br>
            兹证明: id: {{ certificateData.supId }}{{ certificateData.supplierName }}在其营客通ERP账户操作的业务信息内容如下:
          </div>
          <!-- 核心信息表格 -->
          <div class="table-box">
            <table class="info-table">
              <tr>
                <th width="15%">变动时间</th>
                <td width="35%">{{ certificateData.createTime }}</td>
                <th width="15%">明细流水号</th>
                <td width="35%">{{ certificateData.certificateNo }}</td>
              </tr>
              <tr>
                <th>业务类型</th>
                <td colspan="3">服务保证金</td>
              </tr>
              <tr>
                <th>对方公司名称</th>
                <td>上海赢可通信息科技有限公司</td>
                <th>对方账户名称</th>
                <td>营客通ERP服务保证金账户</td>
              </tr>
              <tr>
                <th>金额 (小写)</th>
                <td>{{ certificateData.amount }}元</td>
                <th>金额 (大写)</th>
                <td>{{ convertMoneyToUpper(certificateData.amount) }}</td>
              </tr>
              <tr>
                <th>备注</th>
                <td colspan="3">营客通ERP质保金-充值（代扣）</td>
              </tr>
            </table>
          </div>
          <!-- 使用说明 -->
          <div class="instruction">
            使用说明:<br>
            <ol>
              <li>1、本《营客通服务保证金凭证》仅证明用户在所选时间内其营客通ERP账户中的质保金情况。</li>
              <li>2、本《营客通服务保证金凭证》有任何修改或涂改的，均为无效证明。</li>
              <li>3、本《营客通服务保证金凭证》仅供参考，如与用户营客通ERP账户记录不一致的，以营客通ERP账户记录为准。</li>
            </ol>
          </div>
          <!-- 底部信息 -->
          <div class="footer">
            上海赢可通信息科技有限公司<br>
            申请时间: {{ certificateData.createTime }}
          </div>
        </div>
        <div v-else style="text-align: center;padding:30px 0;color:#666;">暂无凭证数据!</div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="certificateDownload" v-if="certificateData">下载</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetAllReseller,
  KSAXWalletAccountDetail,
  KSAXWalletRecordList,
  KSAXRechargeApplication,
  getQiniuToken,
  ExportWalletRecordList,
  KSAXApiRequest
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";
import html2canvas from "html2canvas";

export default {
  components: { Toolbar },
  data() {
    return {
      detail: {},
      tableData: [],
      total: 0,
      loading: false,
      form: {
        PageIndex: 1,
        PageSize: 10,
        resellerId: null,
        SupId: null,
        RecordType: null,
        StartTime: null,
        EndTime: null,
        Note: null,
      },
      time: null,
      buttonList_toolBar: [],
      buttonList_table: [],
      loanReturn: {
        supId: null,
        amount: null,
        certificate: null,
        note: null
      },
      loanReturnRule: {
        amount: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        certificate: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
      },
      loanReturnVisible: false,
      reseller: [],
      qiniuToken: '',
      supType: null,
      earnestRuleVisible: false,
      certificateVisible: false,
      certificateData: null,
      certificateLoading: false
    };
  },
  watch: {
    time(n, o) {
      this.form.StartTime = n ? n[0] : null;
      this.form.EndTime = n ? n[1] : null;
    },
  },
  created() {
    this.getQiniuToken()
    GetAllReseller({ PageIndex: 1, PageSize: 5 }).then(res => {
      if (res.data.success) {
        this.reseller = res.data.result.items || []
        this.reseller.forEach(item => {
          item.id = item.id.toString()
        })
        this.form.resellerId = this.reseller.length ? this.reseller[0].id : null
        this.supType = this.reseller.length ? this.reseller[0].supType : null
        this.handleReseller()
      } else {
        this.$message.error(res.data.error.message)
      }
    })
  },
  mounted() {
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      this.buttonList_toolBar = buttonList.filter(item => item.buttonShow === 10);
      this.buttonList_table = buttonList.filter(item => item.buttonShow === 20);
    }
  },
  methods: {
    checkCertificate() {
      this.certificateData = null
      this.certificateVisible = true
      this.certificateLoading = true
      let supId = this.reseller.find(i=>i.id==this.form.resellerId).remoteKey

      let data = {
        "path": "SuppliersWalletRecord/Certificate",
        "parms": "",
        "parmsJson": { SupId: Number(supId) }
      }
      KSAXApiRequest(data).then((res) => {
        if (res.data.success) {
          this.certificateData = res.data.response;
        } else {
          this.$message.error(res.data.msg)
        }
        this.certificateLoading = false
      });
    },
    certificateDownload() {
      let dom = document.querySelector('.innerContent')
      html2canvas(dom, {
        useCORS: true,
        scale: 2,
        scrollY: 0,
        scrollX: 0,
        logging: true
      }).then((canvas) => {
        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        this.$utils.downloadBase64Image(imgData, 'certificate.png')
      });
    },
    lookReceiptUrl(url) {
      window.open(url, "_blank")
    },
    getQiniuToken() {
      var that = this;
      getQiniuToken().then((res) => {
        that.qiniuToken = res.data;
      })
        .catch(() => {
        });
    },
    handleReseller() {
      this.supType = this.reseller.filter(val => {
        return val.id == this.form.resellerId
      })[0].supType
      this.resetForm()
      this.queryDetail()
    },
    queryDetail() {
      KSAXWalletAccountDetail({ resellerId: this.form.resellerId }).then(res => {
        if (res.data.success) {
          this.detail = res.data.result.data
        } else {

        }
      })
    },
    queryData() {
      this.loading = true
      KSAXWalletRecordList(this.form).then(res => {
        if (res.data.success) {
          this.tableData = res.data.result.data.data || []
          this.total = res.data.result.data.dataCount
        } else {

        }
        setTimeout(() => {
          this.loading = false
        }, 500)
      })
    },
    getData() {
      this.form.PageIndex = 1
      this.form.PageSize = 10
      this.queryData()
    },
    resetForm() {
      this.time = null
      this.$refs["form"].resetFields();
      this.$nextTick(() => {
        this.getData()
      })
    },
    handleSizeChange(value) {
      this.form.PageSize = value
      this.queryData()
    },
    handleCurrentChange(value) {
      this.form.PageIndex = value
      this.queryData()
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleExport() {
      ExportWalletRecordList(this.form).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '收支明细.xlsx'
        a.href = objectUrl
        a.click()
        a.remove()
      })
      // SupplierContractManageListExport(this.form).then(res => {
      //   if (res.data.success) {
      //     this.$message.success("操作成功，请点击下载中心查看下载结果");
      //   } else {
      //     this.$message.error(res.data.msg)
      //   }
      // })
    },
    loanReturnSure() {
      this.$refs["loanReturnForm"].validate((valid) => {
        if (valid) {
          this.loading = true
          this.loanReturn.supId = this.form.resellerId
          KSAXRechargeApplication(this.loanReturn).then(res => {
            this.loading = false
            if (res.data.result.success) {
              this.$message.success(res.data.result.message)
              this.loanReturnClose()
              this.queryData()
            } else {
              this.$message.error(res.data.result.message)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    loanReturnClose() {
      this.loanReturnVisible = false
      this.$refs.loanReturnForm.resetFields();
    },
    handleChange(file) {
      let that = this
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils.uploadImgToQiniu(file.raw, qiniuData).then((res) => {
        that.loanReturn.certificate = res
      })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    delPic() {
      this.loanReturn.certificate = ''
    },
    convertMoneyToUpper(money) {
      // 处理非数字、空值
      if (money === null || money === undefined || isNaN(Number(money))) {
        return '零元整';
      }
      // 转数字并保留2位小数（处理精度问题）
      let number = Math.abs(Number(money)).toFixed(2);
      const isNegative = Number(money) < 0;

      // 数字大写映射
      const digitUpper = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
      // 单位映射
      const unitInteger = ['', '拾', '佰', '仟', '万', '拾', '佰', '仟', '亿'];
      const unitDecimal = ['角', '分'];

      // 拆分整数 + 小数
      const [integerPart, decimalPart] = number.split('.');
      let result = '';

      // ========== 处理整数部分 ==========
      if (integerPart === '0') {
        result += '零元';
      } else {
        const len = integerPart.length;
        for (let i = 0; i < len; i++) {
          const digit = Number(integerPart[i]);
          const pos = len - i - 1; // 位置

          if (digit !== 0) {
            result += digitUpper[digit] + unitInteger[pos];
          } else {
            // 避免连续零
            if (result.slice(-1) !== '零') {
              result += '零';
            }
          }
        }
        // 去掉末尾多余的零
        result = result.replace(/零+$/, '') + '元';
      }

      // ========== 处理小数部分 ==========
      const jiao = Number(decimalPart[0]);
      const fen = Number(decimalPart[1]);

      if (jiao === 0 && fen === 0) {
        result += '整';
      } else {
        if (jiao !== 0) result += digitUpper[jiao] + '角';
        if (fen !== 0) result += digitUpper[fen] + '分';
      }

      // ========== 处理负数 ==========
      if (isNegative) {
        result = '负' + result;
      }

      return result;
    }
  },
};
</script>

<style scoped>
.flex-wrap {
  display: flex;
}

.mgr30 {
  margin-right: 30px;
}

h2 {
  display: inline-block;
}

.card>>>.el-form-item__content {
  word-wrap: break-word;
}

.card>>>.el-card__body {
  padding: 0px;
  background: #f1f1f1;
}

.img-box .el_upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}

.img-box .el_upload:hover {
  border-color: #409eff;
}

.img-box .el_upload:hover .mask {
  opacity: 1;
}

.img-box .mask {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  line-height: 120px;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
}

.img-box .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px !important;
  text-align: center;
}

.img-box .avatar {
  width: 120px;
  height: 120px;
}

.earnestRule {
  color: red;
  cursor: pointer;
  margin-left: 10px;
  border-bottom: 1px solid red;
  padding-bottom: 0px;
}

.pzRule {
  color: #0087ff;
  cursor: pointer;
  margin-left: 10px;
  border-bottom: 1px solid #0087ff;
  padding-bottom: 0px;
}

.innerContent {
  margin: 20px auto;
  padding: 30px 50px;
  border: 1px solid #eee;
}

.innerContent .title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 40px;
  color: #000;
}

.base-info {
  font-size: 14px;
  line-height: 2.5;
  color: #333;
}

.table-box {
  margin: 20px 0;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.info-table th,
.info-table td {
  border: 1px solid #d3d3d3;
  padding: 10px;
  text-align: left;
}

.info-table th {
  background-color: #f5f5f5;
}

.instruction {
  font-size: 14px;
  line-height: 2;
  margin: 30px 0 50px 0;
}

.footer {
  font-size: 16px;
  text-align: right;
  line-height: 2;
  color: #333;
}
</style>
